// Core vendor imports
import "jquery-match-height";
import gsap             from "gsap";
import Alpine           from "alpinejs";
import ScrollTrigger    from "gsap/ScrollTrigger";
import imagesLoaded     from "imagesloaded";

// Utility scripts
import Locomotive, { locoScroll, scrollContainer} from './utilities/locomotive';
import LoadMore from "./utilities/loadmore";

// Components scripts
import Universal        from './components/universal';
import SplitText        from './components/splittext';
import ScrollSpy        from "./components/scrollspy";
import Images           from './components/images';
import sectionBGChanger from './components/bgTransition';
// import Reellers         from "./components/reeller";
import Header           from "./components/header";
import Menu             from "./components/menu";
import StackedSection   from "./components/stacked-section";
import Search           from "./components/search";
import { DictionaryArchive, DictionaryTippys } from "./components/dictionary";

// Page scripts
import Blog from "./pages/blog";
import $ from "jquery";
import Helpers from "./utilities/helpers";
import ContactUs from "./pages/contact-us";
import AJAXForm from "./components/AJAXForm";
import Events from "./components/events";
import BlogSignUpModalHandler from "./components/BlogSignUpModalHandler";
import ArticleInsight from "./components/ArticleInsight";


gsap.registerPlugin(ScrollTrigger);

gsap.config({
  nullTargetWarn: false
});

// Config GSAP
gsap.defaults({
  ease: "power3.out",
  duration: "1"
});

ScrollTrigger.defaults({
  scroller: scrollContainer,
  start: "top bottom-=20%"
});

// ignoreMobileResize
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
  ScrollTrigger.config({
    autoRefreshEvents: 'DOMContentLoaded,load' // "visibilitychange, resize," isn't in the list
  });
}

ScrollSpy();
Header();
Menu();
LoadMore();
StackedSection();
Search();
Blog();
DictionaryTippys();
Events();
BlogSignUpModalHandler()
ArticleInsight()
if ( Helpers.isPage( "contact-us" ) ) {
    ContactUs();    
}

if ( Helpers.isPage( "archive-dictionary-term" ) ) {
    DictionaryArchive();
}

// Initialise footer subscribe with all it's bells and whistles. (ajax)
$( function () {
    const ajaxForm = new AJAXForm( "footer-subscribe" );

    // Set event handler for successful post.
    // ajaxForm.handleSuccess( function ( data ) {
    //     $( "#footer-subscribe-result" ).removeClass( "text-red-500 hidden" ).addClass( "text-green-500" ).text( "You have been successfully subscribed." );
    // } );

    // Set event handler for failed post (unvalidated inputs).
    ajaxForm.handleInvalid( function ( ) {
        $( "#footer-subscribe-result" ).removeClass( "text-green-500 hidden" ).addClass( "text-red-500" ).text( "Please fill in all fields." );
    } );

    // Set event handler for complete server error.
    ajaxForm.handleError( function ( data ) {
        $( "#footer-subscribe-result" ).removeClass( "text-green-500 hidden" ).addClass( "text-red-500" ).text( "Something went wrong while subscribing you to this list. Please try again later." );
    } );
} );

// Initialise buy rent calculator with all it's bells and whistles. (ajax)


$( function () {
    const ajaxForm = new AJAXForm( "side-custom-form" );

    // Set event handler for successful post.
    ajaxForm.handleSuccess( function ( data ) {
    } );

} );


$(function () {
    const form = document.querySelector("#mc-custom-form");
    if (!form) return;

    form.addEventListener("submit", function(event) {
        event.preventDefault();  // Prevent the default form submission
        const formData = new FormData(this);

        const emailList = formData.get("email_list");


        const inputs = event.target.querySelectorAll("input");
        let email = "";


        inputs.forEach(input => {
            if (input.name === "email") {
                email = input.value;
            }
        });

        mixpanel.track("ifg:blogForm_submitted", {
            email: email,
            postTitle: emailList,
            page: window.location.href
        });


        // Perform the AJAX request (using fetch)
        fetch(window.location.origin + '/wp-admin/admin-ajax.php', {
            method: "POST",
            body: formData
        })
            .then(data => {
                const resultElement = document.querySelector("#blog-subscribe-result");

                if (data.status == 200) {
                    // If the subscription is successful, show the success message
                    resultElement.textContent = "You have been successfully subscribed.";
                    resultElement.classList.remove("text-red-500", "hidden");
                    resultElement.classList.add("text-green-500");

                    // Reset the form fields
                    document.querySelector("#mc-custom-form").reset();
                    resultElement.style.display = "flex"; // Ensure it's visible

                } else {
                    // If subscription failed, show an error message
                    resultElement.textContent = "Error while subscribing.";
                    resultElement.classList.remove("text-green-500", "hidden");
                    resultElement.classList.add("text-red-500");
                    resultElement.style.display = "flex";
                }
            })
            .catch(error => {
                console.log("Error submitting form:", error);
            });
    });
})


// Mixpanel tracking.
// $( function () {
//     $( "#main-search" ).on( "click", function () { 
//         window.mixpanel?.track( "ifg:website_searchClicked" );
//     })
// } );
